import { render, staticRenderFns } from "./DraggableDiv.vue?vue&type=template&id=351d7500&scoped=true"
import script from "./DraggableDiv.vue?vue&type=script&lang=js"
export * from "./DraggableDiv.vue?vue&type=script&lang=js"
import style0 from "./DraggableDiv.vue?vue&type=style&index=0&id=351d7500&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351d7500",
  null
  
)

export default component.exports